// React.
import { createContext } from 'react';

// Types.
import Filter from '../types/Filter';
import FilterOption from '../types/instance/FilterOption';

// Define the context type, including the update function.
export type FilterContextType =
{
    filters: Filter[],
    setFilters: (filters: Filter[]) => void,
    currentFilterOptions: FilterOption[],
    setCurrentFilterOptions: (options: FilterOption[]) => void
}

// Define the default context object.
export const FilterContext = createContext<FilterContextType>
({
	filters: [],
	setFilters: filters => console.warn ('Filters not set', filters),
	currentFilterOptions: [],
	setCurrentFilterOptions: options => console.warn ('Current filter options not set', options)
});

FilterContext.displayName = 'Filters';
